// News search functionality
((window, document) => {
  // Get the back button and the pagination
  const backBtn = document.querySelector('.js-body-link');
  const pagination = document.querySelector('.js-pagination-container');
  const newsTypeElements = document.querySelectorAll('.js-news-type');
  const newsTypeLinks = document.querySelectorAll('.js-news-type-link');
  const guidesPage = window.location.href.indexOf('guides') > -1;

  // Replace All instances of News with Guides where applicable
  const replaceNewsTypes = () => {
    if (newsTypeElements && guidesPage) {
      newsTypeElements.forEach((el) => {
        el.textContent = 'guides';
      });
    }
  };

  // Replace All instances of News href values with Guides where applicable
  const replaceNewsLinks = () => {
    if (newsTypeLinks && guidesPage) {
      newsTypeLinks.forEach((el) => {
        el.href = '/guides/';
      });
    }
  };

  // Get the params from the URL
  const getUrlVars = () => {
    const vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
      vars[key] = value;
    });
    return vars;
  };

  const searchTerm = getUrlVars().searchNews;
  const searchAction = getUrlVars().search;

  const paginationUrl = () => {
    const getLinks = document.querySelectorAll('.js-pagination-container .Result_Page_Other > a');
    // Get the values of all the pagination links and replace with our new URL
    getLinks.forEach((link) => {
      const hrefValue = link.href.split('/')[4];
      const newHref = `${hrefValue}&searchNews=${searchTerm}&search=${searchAction}`;
      link.setAttribute('href', newHref);
    });
  };

  // Alert if results return no vehicles
  const showAlert = () => {
    const articleHistory = document.querySelector('.js-article-container--history');
    const article = articleHistory.querySelectorAll('.article');
    const sortNav = document.querySelector('.js-sort-navigate');
    const keyword = searchTerm;

    if (article.length !== 0) {
      return;
    }

    // Build the HTML template for the alrt
    const alertTemplate = `
      <div class="alert alert--primary icon__info js-alert">
       <p class="text--white text-align--center lead-text">Sorry we could'nt find any results relating to <span class="font--bold text--underline">${keyword}</span></p>
      </div>
    `;

    // Hide the pagination and sort nav
    pagination.style.display = 'none';
    sortNav.style.display = 'none';
    // Insert the alertTemplate before the articles div
    articleHistory.insertAdjacentHTML('beforebegin', alertTemplate);
  };

  // Check the session storage if we have our values
  const checkUrlParams = () => {
    const featArticles = document.querySelector('.js-featured-articles');

    // If the URL has either of the params then hide the featured articles
    if (typeof searchTerm !== 'undefined' && typeof searchAction !== 'undefined') {
      featArticles.style.display = 'none';
      backBtn.classList.remove('hide__default');
      paginationUrl();
      showAlert();
    }
  };

  // Add click listener to button
  backBtn.addEventListener('click', () => {
    backBtn.classList.add('hide__default');
  });

  vm.onload(() => {
    // Replace the news type elements
    replaceNewsLinks();
    replaceNewsTypes();

    // Run the ceckUrlParams function
    checkUrlParams();
  });
})(window, document);
